<!-- eslint-disable max-len -->
<!--- Formulario FrmExpeditionDocumentAddPale ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-

Eventos escuchados por el formulario:
-----------------------

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page class="main-expedition-document-add-pale ">
    <template #fixed>
      <TheNavbar
        v-if="lineSelected != null"
        :nav-title="`${lineSelected.Expedicion.Serie} / ${lineSelected.Expedicion.Numero}`"
        :back-btn-enable="true"
        :back-callback="goBack"
        :style="appTheme"
      >
        <template #right>
          <div
            v-if="expedition.EstadoOrdenCarga !== 2"
            class="display-flex"
          >
            <f7-link
              icon="icon-delete"
              @click="EventDeleteLine"
            />
            <f7-link
              @click="EventOpenReadAnsForCarga"
            >
              <img :src="icQr">
            </f7-link>
          </div>
        </template>
      </TheNavbar>
    </template>

    <div
      v-if="lineSelected != null"
      class="content-data padding"
    >
      <div class="content-data__row">
        <div class="content-data__col">
          <div class="content-data__col--gray">
            {{ $t('common.customer') }}
          </div>
          <div
            v-if="lineSelected.Cliente != null"
            class="content-data__col--strong-blue"
          >
            <!-- <pre>{{ lineSelected }}</pre> -->
            {{ lineSelected.Cliente.Nombre }}
          </div>
        </div>
        <div class="content-data__info">
          <div
            v-if="lineSelected.Cliente != null"
            class="content-data__info--strong-blue"
          >
            {{ lineSelected.CantidadTotalCargada }} <span>{{ $t('common.of') }}</span> {{ lineSelected.CantidadTotalPales }}
          </div>
          <img :src="icPalet">
        </div>
      </div>
      <div class="content-data__row margin-top-half">
        <div class="content-data__col">
          <div class="content-data__col--gray">
            {{ $t('common.salesOrderShort') }}
          </div>
          <div class="content-data__col--strong-blue">
            {{
              (lineSelected.LineaPedidoVenta.PedidoVenta === null
                ? ''
                : `${lineSelected.LineaPedidoVenta.PedidoVenta.Serie === null
                  ? ''
                  : lineSelected.LineaPedidoVenta.PedidoVenta.Serie}/${lineSelected.LineaPedidoVenta.PedidoVenta.Numero}-${lineSelected.LineaPedidoVenta.Orden}`)
            }}
          </div>
        </div>
      </div>
      <div class="content-data__row margin-top-half">
        <div class="content-data__col">
          <div class="content-data__col--gray">
            {{ $t('common.product') }}
          </div>
          <div
            v-if="lineSelected.Producto != null"
            class="content-data__col--strong-blue"
          >
            {{ lineSelected.Producto.Nombre }}
          </div>
        </div>
      </div>
      <div class="content-data__row margin-top-half">
        <div
          v-if="lineSelected.Marca != null"
          class="content-data__col"
        >
          <div class="content-data__col--gray">
            {{ $t('common.brand') }}
          </div>
          <div
            class="content-data__col--strong-blue"
          >
            {{ lineSelected.Marca.Nombre }}
          </div>
        </div>
        <div class="content-data__col">
          <div class="content-data__col--gray">
            {{ $t('common.format') }}
          </div>
          <div
            v-if="lineSelected.Envase != null"
            class="content-data__col--strong-blue"
          >
            {{ lineSelected.Envase.Nombre }}
          </div>
        </div>
      </div>
    </div>
    <!-- Palets Cargados -->
    <f7-block class="content-data no-padding">
      <UCAcordeon
        title-option="Estado"
        font-color="#fff"
        title-sub-option="Orden"
        :items="paletsCargados"
        :closed="false"
        :show-badge="false"
        :show-checkbox="expedition.EstadoOrdenCarga !== 2 ? true : false"
        :checkbox-row-title="$t('common.allPl')"
        :after-title="false"
        :disabled-btn-options-no-items-selected="true"
        @open-options="actionChargesOpened = expedition.EstadoOrdenCarga !== 2"
      >
        <template #subOptionSubtitle="{ item }">
          <f7-list
            media-list
            :class="filtradoPorNumeroSerie === item.UnidadContenedora.NumeroSerie ? 'suboption-list-fondo' : 'suboption-list'"
          >
            <f7-list-item>
              <template #title>
                <div
                  style="display: flex;
align-items: center;
justify-content: space-between;
padding-right: 20px;"
                >
                  {{ item.UnidadContenedora.NumeroSerie }}
                  <span
                    v-if="item.UnidadContenedora.Mixta"
                    class="suboption-list__mix"
                  > {{ $t('commercialization.common.mixedPallet') }} </span>
                </div>
              </template>

              <template #footer>
                <div v-if="!item.disabled">
                  {{ `${$t('commercialization.common.palletTemperature')} ${item.TemperaturaPale}°C` }}
                </div>

                <div v-if="item.disabled">
                  {{ $t('commercialization.common.loadedFromAnotherLine') }}
                </div>
              </template>

              <template #after>
                <div>
                  {{ item.UnidadContenedora.CantidadEnvases }}
                </div>
              </template>
            </f7-list-item>
          </f7-list>
        </template>
      </UCAcordeon>
      <UCAcordeon
        title-option="Estado"
        primary="#979797"
        font-color="#fff"
        title-sub-option="Orden"
        :items="paletsReservados"
        :closed="false"
        :show-badge="false"
        :show-checkbox="expedition.EstadoOrdenCarga !== 2 ? true : false"
        :checkbox-row-title="$t('common.allPl')"
        :after-title="false"
        :disabled-btn-options-no-items-selected="false"
        @open-options="EventOpenActionsReservation(expedition.EstadoOrdenCarga !== 2)"
      >
        <template #subOptionSubtitle="{ item }">
          <f7-list
            media-list
            class="suboption-list"
          >
            <f7-list-item>
              <template #title>
                <div
                  :style="{
                    'display': 'flex',
                    'align-items': 'center',
                    'justify-content': 'space-between',
                  }"
                >
                  {{ item.UnidadContenedora.NumeroSerie }}
                  <span
                    v-if="item.UnidadContenedora.Mixta"
                    class="suboption-list__mix"
                  > {{ $t('commercialization.common.mixedPallet') }} </span>
                </div>
              </template>

              <template #subtitle>
                <div>
                  {{ item.UnidadContenedora.Ubicacion != null ? item.UnidadContenedora.Ubicacion.Nombre : $t('common.locationUnknown') }}
                </div>
              </template>

              <!-- <template #after>
                <div>
                  <img
                    src="@/static/img/ic_button_edit.svg"
                    alt="iconTemp"
                    @click="Addtemperature(item)"
                  >
                </div>
              </template> -->

              <template #footer>
                <div v-if="!item.disabled">
                  {{ `${$t('commercialization.common.palletTemperature')} ${item.TemperaturaPale}°C` }}
                </div>
                <div v-if="item.disabled">
                  {{ $t('commercialization.common.reservedFromAnotherLine') }}
                </div>
              </template>

              <template #after>
                <div>
                  {{ item.UnidadContenedora.CantidadEnvases }}
                </div>
              </template>
            </f7-list-item>
          </f7-list>
        </template>
      </UCAcordeon>
      <!-- Palets Sin Reserva -->
      <UCAcordeon
        title-option="Estado"
        font-color="#fff"
        primary="var(--his-orange)"
        title-sub-option="Orden"
        :items="paletsSinReserva"
        :closed="false"
        :show-badge="false"
        :show-checkbox="expedition.EstadoOrdenCarga !== 2 ? true : false"
        :checkbox-row-title="$t('common.allPl')"
        :after-title="false"
        :disabled-btn-options-no-items-selected="true"
        @open-options="actionReservationSalesOrderLineOpened = expedition.EstadoOrdenCarga !== 2"
      >
        <template #subOptionSubtitle="{ item }">
          <f7-list
            media-list
            class="suboption-list no-padding"
          >
            <f7-list-item>
              <template #title>
                <div>
                  {{ item.UnidadContenedora.NumeroSerie }}
                </div>
              </template>

              <template #after>
                <div class="item-after" />
              </template>
            </f7-list-item>
          </f7-list>
        </template>
      </UCAcordeon>
    </f7-block>

    <!-- ACTION DEL FORMULARIO -->
    <div>
      <!-- Action sobre Pales CARGADOS. -->
      <f7-actions
        class="content-action"
        :grid="true"
        :opened="actionChargesOpened"
        @actions:closed="actionChargesOpened = false"
      >
        <f7-actions-group>
          <f7-actions-label>
            {{ $t('common.whatDoYouWantToDo') }}
          </f7-actions-label>
          <div class="content-action__buttons">
            <f7-actions-button
              class="content-action__buttons--red"
              @click="DeleteCharge()"
            >
              <template #media>
                <img
                  src="@/static/icons/ic_delete.svg"
                  width="50"
                  class="img-delete"
                >
              </template>
              <span>{{ $t('commercialization.common.deleteLoad') }}</span>
            </f7-actions-button>
            <f7-actions-button
              class="content-action__buttons--green"
              @click="actionReservationOpened = false; actionAddTemperature = true ; itemSelected = 0"
            >
              <template #media>
                <img
                  src="@/static/img/ic_button_edit.svg"
                  width="50"
                  class="img-delete"
                >
              </template>
              <span>{{ $t('commercialization.common.changeTemperature') }}</span>
            </f7-actions-button>
          </div>
        </f7-actions-group>
      </f7-actions>
      <!-- Action sobre Pales RESERVADOS ORDEN DE CARGA -->
      <f7-actions
        class="content-action"
        :grid="true"
        :opened="actionReservationOpened"
        @actions:closed="actionReservationOpened = false"
      >
        <f7-actions-group>
          <f7-actions-label>
            {{ $t('common.whatDoYouWantToDo') }}
          </f7-actions-label>
          <div class="content-action__buttons">
            <f7-actions-button
              v-if="showOptionDeleteReservation"
              class="content-action__buttons--red"
              @click="DeleteReservationSelected()"
            >
              <template #media>
                <img
                  src="@/static/icons/ic_delete.svg"
                  width="50"
                  class="img-delete"
                >
              </template>
              <span>{{ $t('commercialization.common.deleteReservation ') }}</span>
            </f7-actions-button>
            <f7-actions-button
              v-if="showOptionChargeReservation"
              class="content-action__buttons--green"
              @click="ChargeSelectedPales()"
            >
              <template #media>
                <img
                  src="@/static/icons/ic_addGreen.svg"
                  width="50"
                  class="img-delete"
                >
              </template>
              <span>{{ $t('commercialization.common.loadPallet') }}</span>
            </f7-actions-button>
            <f7-actions-button
              v-if="showOptionChargeReservation"
              class="content-action__buttons--green"
              @click="actionReservationOpened = false; actionAddTemperature = true; itemSelected = 1 "
            >
              <template #media>
                <img

                  src="@/static/img/ic_button_edit.svg"
                  width="50"
                  class="img-delete"
                >
              </template>
              <span>{{ $t('commercialization.common.changeTemperature') }}</span>
            </f7-actions-button>
            <f7-actions-button
              v-if="!showOptionChargeReservation && !showOptionDeleteReservation"
              class="content-action__buttons--gray"
              @click="EventOpenReadAnsForReservation()"
            >
              <template #media>
                <img
                  src="@/static/icons/ic_qr.svg"
                  width="50"
                  class="img-add"
                >
              </template>
              <span>{{ $t('commercialization.common.addNewPalletReservation') }}</span>
            </f7-actions-button>
          </div>
        </f7-actions-group>
      </f7-actions>

      <!-- Action sobre Pales RESERVADOS LINEA PEDIDO VENTA -->
      <f7-actions
        class="content-action"
        :grid="true"
        :opened="actionReservationSalesOrderLineOpened"
        @actions:closed="actionReservationSalesOrderLineOpened = false"
      >
        <f7-actions-group>
          <f7-actions-label>
            {{ $t('common.whatDoYouWantToDo') }}
          </f7-actions-label>
          <div class="content-action__buttons">
            <f7-actions-button
              class="content-action__buttons--gray"
              @click="ProcessSelectedPalesReserve()"
            >
              <template #media>
                <img
                  src="@/static/icons/ic_addGreen.svg"
                  width="50"
                >
              </template>
              <span>{{ $t('commercialization.common.reservePallet') }}</span>
            </f7-actions-button>
            <f7-actions-button
              class="content-action__buttons--green"
              @click="ChargeAndAddForReservSelectedPales()"
            >
              <template #media>
                <img
                  src="@/static/icons/ic_addGreen.svg"
                  width="50"
                  class="img-delete"
                >
              </template>
              <span>{{ $t('commercialization.common.reserveAndLoadPallet') }}</span>
            </f7-actions-button>
          </div>
        </f7-actions-group>
      </f7-actions>
      <f7-actions
        class="content-action"
        :grid="true"
        :opened="actionAddTemperature"
        @actions:closed="actionAddTemperature = false"
      >
        <f7-actions-group>
          <f7-actions-label>{{ $t('commercialization.common.enterPalletTemperature') }}</f7-actions-label>
          <div class="input-temperatura">
            <f7-input
              outline
              style="padding-bottom: 10px;
padding-top: 10px;"
              type="number"
              step=".001"
              :placeholder="$t('commercialization.common.palletTemperature')"
              clear-button
              @input="temperatura = $event.target.value"
            />
          </div>
          <div class="content-action__buttons">
            <f7-actions-button
              class="actions-button--cancelar"
              @click="actionAddTemperature = false"
            >
              {{ $t('common.cancel') }}
            </f7-actions-button>
            <f7-actions-button
              class="actions-button--guardar"
              bold
              @click="(itemSelected === 0) ? ChangeTemperaturePaletsSelectedCargados() : ChangeTemperaturePaletsSelectedReservados()"
            >
              {{ $t('common.save') }}
            </f7-actions-button>
          </div>
        </f7-actions-group>

        <!-- <f7-actions-label style="font-weight: 500;">{{ $t('commercialization.common.enterPalletTemperature') }}</f7-actions-label>
        <div class="content-action__buttons">
          <f7-input
            type="number"
            step=".001"
            clear-button
            @input="temperatura = $event.target.value"
          />
        </div> -->
      </f7-actions>
    </div>

    <UCCodeScanner
      ref="UCCodeScannerNotifyAddPale"
      :continuous-bar-code-reading="true"
      :allow-manual-code-entry="true"
      :fab-button-show="false"
      :open-information-bar="infoSheetParams.opened"
      :title="infoSheetParams.title"
      :subtitle1="infoSheetParams.subtitle1"
      :state="infoSheetParams.state"
      @code-reading="EventBarCodeReading"
      @popup-close="EventScannerCamClose"
      @codigo-barras="EventBarCodeReading"
      @numero-serie="EventNumeroSerieReading"
    >
      <template #slotShowInfo>
        <div>
          <div class="quantityCharged padding-bottom">
            <span class="margin-right ">
              {{ `${lineSelected.CantidadTotalCargada} ${$t('common.of')} ${lineSelected.CantidadTotalPales}` }}
            </span>
            <img :src="icPaletEscaner">
          </div>
        </div>
      </template>
    </UCCodeScanner>
    <!-- popup mostrar datos despues del escaneo de pale -->
    <PCPopupScanData
      ref="PCPopupScanData"
      @confirm="EventConfirmScanData"
    />
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useParamRef } from '@erpagroapp/params';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import APIErp, {
  callMoveReservedPalletDifferentExpedition,
} from '@/js/services/APIErp';
import ConexionTA from '@/js/services/traceability/APITraceability';
import {
  ConfirmDialogGH,
  HiDialog,
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import PCPopupScanData from '@/components/production/commercialization/picking/PCPopupScanData.vue';
import icPalet from '@/static/icons/ic_palet_2.svg';
import icPaletEscaner from '@/static/icons/ic_palet_02.svg';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import icQr from '@/static/icons/ic_qr.svg';
import { ComponentState } from '@/js/common/enum';
import TheNavbar from '@/components/TheNavbar.vue';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';

import CargaCorrecta from '@/static/sounds/CargaCorrecta.mp3';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';
import { useSound } from '@/composables/useSound';
import { EliminacionReservaClienteInterno } from '@/js/enums/commercialisation';

/** @import { Cliente, InfoSheetState } from '@erpagroapp/types' */

export default {
  name: 'FrmExpeditionDocumentAddPale',
  components: {
    UCAcordeon,
    TheNavbar,
    PCPopupScanData,
    UCCodeScanner,
  },
  props: {
    lineExpedition: { type: Object, default: null },
    expedition: { type: Object, default: null },
    filtradoPorNumeroSerie: { type: String, default: null, require: false },
  },

  emits: ['state-change'],

  data() {
    return {
      icQr,
      icPalet,
      icPaletEscaner,
      paletsCargados: [
        {
          Estado: this.$t('commercialization.common.loadedPallets'),
          items: [],
        },
      ],
      paletsReservados: [
        {
          Estado: this.$t('commercialization.common.reservedPalletsToOrder'),
          items: [],
        },
      ],
      paletsSinReserva: [
        {
          Estado: this.$t('commercialization.common.reservedPalletsToSalesOrder'),
          items: [],
        },
      ],
      actionChargesOpened: false, // Controla la apertura del actión de cargas.
      actionReservationOpened: false, // Controla la apertura del actión de reservas de la orden de carga.
      actionReservationSalesOrderLineOpened: false, // Controla la apertura del actión de reservas de la linea pedido venta.
      actionAddTemperature: false,
      temperatura: '',
      showOptionDeleteReservation: false, // Controla si se muestra la opción de eliminar reserva
      showOptionChargeReservation: false, // Controla si se muestra la opción de cargas palés seleccionados.
      modificado: false, // es true si se modifica el array de datos inicial
      lineSelected: null,
      lecturaParaReservaActiva: false, // controla si la lectura es para reserva o para carga
      itemSelected: null, // pale seleccionado
      movePalletFromOtherLoadingOrder: false,
      isProcessingContinousReadingsQueue: false,
      /** @type {{ Id: number } & ({ NumeroSerie: string } | { CodigoBarrasPale: string })[]} */
      continuousReadingsQueue: [],
      introduccionManualCBLecturaPalesExpeciones: useParamRef('IntroduccionManualCBLecturaPalesExpeciones'),
      lecturaContinuaCargasExpediciones: useParamRef('LecturaContinuaCargasExpediciones'),
      eliminarReservaAnteriorExpediciones: useParamRef('EliminarReservaAnteriorExpediciones'),
      eliminarReservaClientesInternosExpediciones: useParamRef('EliminarReservaClientesInternosExpediciones'),
      permitirMoverPalesReservadosEnOrdenCarga: useParamRef('PermitirMoverPalesReservadosEnOrdenCarga'),
      soundCargaCorrecta: useSound(CargaCorrecta),
      infoSheetParams: {
        opened: false,
        title: '',
        subtitle1: null,
        /** @type {InfoSheetState} */
        state: 'CAUTION',
      },
    };
  },

  computed: {
    ...mapState(useAppConfigStore, ['userEnviroment']),

    componentState() {
      return !this.modificado ? ComponentState.INITIAL : ComponentState.EDIT;
    },
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },
  },

  watch: {
    componentState(val) {
      this.$emit('state-change', val);
    },
  },
  mounted() {
    if (this.filtradoPorNumeroSerie != null) {
      this.modificado = true;
    }
  },

  created() {
    this.modificado = false;
    this.StartDocument();
  },

  methods: {

    StartDocument() {
      this.lineSelected = { ...this.lineExpedition };
      this.ProcessingDataGET();
    },
    /** Method ProcessingDataGET */
    async ProcessingDataGET() {
      Log(this, this.ProcessingDataGET.name);
      const cargados = [];
      const planificados = [];
      this.lineSelected.Desglose.forEach((e) => {
        if (e.Estado === 2) {
          cargados.push(e);
        } else if ((e.Estado === 0 || e.Estado === 1) && e.UnidadContenedora != null) { // Pendiente o EnTransito
          planificados.push(e);
        }
      });
      // Palés Cargados en otra linea
      if (this.lineSelected.RelacionesConOtrasCargas.length > 0) {
        this.lineSelected.RelacionesConOtrasCargas[0].Desglose.forEach((e) => {
          if (e.Estado === 2) {
            if (!cargados.some((x) => x.Id === e.Id)) {
              e.disabled = true;
              cargados.push(e);
            }
          } else if ((e.Estado === 0 || e.Estado === 1) && e.UnidadContenedora != null) { // Pendiente o EnTransito
            if (!planificados.some((x) => x.Id === e.Id)) {
              e.disabled = true;
              planificados.push(e);
            }
          }
        });
      }

      this.paletsCargados[0].items = cargados;
      this.paletsCargados[0].items.forEach((e) => {
        e.checked = false;
      });
      this.paletsReservados[0].items = planificados;
      this.paletsReservados[0].items.forEach((e) => {
        e.checked = false;
      });
      // Calculo de cantidades Totales
      this.paletsReservados[0].items.forEach((e) => {
        let cantidadEnvases = 0;
        let cantidadProducto = 0;
        e.UnidadContenedora.Existencias.forEach((ex) => {
          if (Number(ex.Articulo.TipoArticulo) === 1) {
            cantidadEnvases += Number(ex.Cantidad);
          }
          if (Number(ex.Articulo.TipoArticulo) === 2) {
            cantidadProducto += Number(ex.Cantidad);
          }
        });
        e.UnidadContenedora.CantidadEnvases = cantidadEnvases;
        e.UnidadContenedora.CantidadProducto = cantidadProducto;
      });
      this.paletsCargados[0].items.forEach((e) => {
        let cantidadEnvases = 0;
        let cantidadProducto = 0;
        e.UnidadContenedora.Existencias.forEach((ex) => {
          if (Number(ex.Articulo.TipoArticulo) === 1) {
            cantidadEnvases += Number(ex.Cantidad);
          }
          if (Number(ex.Articulo.TipoArticulo) === 2) {
            cantidadProducto += Number(ex.Cantidad);
          }
        });
        e.UnidadContenedora.CantidadEnvases = cantidadEnvases;
        e.UnidadContenedora.CantidadProducto = cantidadProducto;
      });
      this.lineSelected.CantidadTotalCargada = this.paletsCargados[0].items.length;
      await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
    },
    /** Method GetReservationXLine */
    async GetReservationXLine(idLineSalesOrder) {
      this.paletsSinReserva[0].items = [];
      this.paletsSinReserva[0].Preload = true;
      let result = null;
      try {
        result = await APIErp.callReservedSerialNumbersXSalesOrderLines(idLineSalesOrder);
      } catch (error) {
        LogError(this, this.GetReservationXLine.name, error);
      }
      this.paletsSinReserva[0].Preload = false;
      if (result != null && (result.statusText === 'OK' || result.status === 200)) {
        this.paletsSinReserva[0].items = result.data.filter((e) => e.ReservaExpedicion === null);
        this.paletsSinReserva[0].items.forEach((e) => {
          e.checked = false;
        });
        // Calculo de cantidades Totales
        this.paletsSinReserva[0].items.forEach((e) => {
          let cantidadEnvases = 0;
          let cantidadProducto = 0;
          if (e.UnidadContenedora.cantidadEnvases === null || e.UnidadContenedora.cantidadEnvases === 0) {
            e.UnidadContenedora.Existencias.forEach((ex) => {
              if (Number(ex.Articulo.TipoArticulo) === 1) {
                cantidadEnvases += Number(ex.Cantidad);
              }
              if (Number(ex.Articulo.TipoArticulo) === 2) {
                cantidadProducto += Number(ex.Cantidad);
              }
            });
            e.UnidadContenedora.CantidadEnvases = cantidadEnvases;
            e.UnidadContenedora.CantidadProducto = cantidadProducto;
          }
        });
      } else {
        HiNotification.Toast(this.$t('commercialization.info.orderLinesReservationsCheckError'));
      }
    },

    async DeleteCharge() {
      Log(this, this.DeleteCharge.name);
      this.paletsCargados[0].items.forEach(async (l) => {
        if (l.checked) {
          // this.newListaCheck.forEach(async (l) => {
          HiDialog.Preloader(true, this.$t('commercialization.info.deletingPalletLoad', { pallet: l.UnidadContenedora.NumeroSerie }), false);
          let result = { valor: false };
          try {
            result = await this.Conections_ChangeStatusPallet(l.UnidadContenedora.Id, l.Id, this.lineSelected.Expedicion.Id, 0);
          } catch (error) {
            LogError(this, this.DeleteCharge.name, error);
          }
          HiDialog.Preloader(false);
          if (result.valor) {
            l.EstadoCarga = 0;
            this.paletsCargados[0].items = this.paletsCargados[0].items.filter((item) => item.Id !== l.Id); // Eliminamos el cargado
            this.paletsReservados[0].items.push(l);
            this.lineSelected.CantidadTotalCargada = this.paletsCargados[0].items.length;
          } else {
            HiNotification.Alert(this.$t('commercialization.info.couldNotDeletePalletLoad'), this.$t('common.warning'));
          }
        }
      });
      this.paletsCargados[0].items.forEach((e) => {
        e.checked = false;
      });
      this.modificado = true;
    },
    async DeleteReservationSelected() {
      Log(this, this.DeleteReservationSelected.name);
      const forDeletion = [];
      for await (const e of this.paletsReservados[0].items.filter((item) => item.checked)) {
        HiDialog.Preloader(true, this.$t('commercialization.info.deletingPalletReservation', { pallet: e.UnidadContenedora.NumeroSerie }), false);
        const result = await APIErp.callBorrarReservaXOrdenCarga(e.UnidadContenedora.Id, e.Id, this.lineSelected.Expedicion.Id);
        if (result.statusText === 'OK' || result.status === 200) {
          forDeletion.push(e);
          const dl = this.lineSelected.Desglose.find((j) => j.Id === e.Id);
          dl.Estado = 0;
          dl.UnidadContenedora = null;
        }
        HiDialog.Preloader(false);
      }
      this.paletsReservados[0].items.forEach((e) => {
        e.checked = false;
      });
      this.paletsReservados[0].items = this.paletsReservados[0].items.filter((item) => !forDeletion.includes(item));
      await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
      this.modificado = true;
    },
    async ChangeTemperaturePaletsSelectedReservados() {
      Log(this, this.ChangeTemperaturePaletsSelectedReservados.name);
      this.paletsReservados[0].items.forEach(async (l) => {
        if (l.checked) {
          // this.newListaCheck.forEach(async (l) => {
          HiDialog.Preloader(true, this.$t('commercialization.info.changingPalletTemperature', { pallet: l.UnidadContenedora.NumeroSerie }), false);
          let result = { valor: false };
          try {
            result = await this.Conections_ChangeTemperaturePale(l.UnidadContenedora.Id, l.Id, this.temperatura);
          } catch (error) {
            LogError(this, this.ChangeTemperaturePaletsSelectedReservados.name, error);
          }
          HiDialog.Preloader(false);
          if (result.valor) {
            l.TemperaturaPale = this.temperatura;
          } else {
            HiNotification.Alert(this.$t('commercialization.info.couldNotChangePalletTemperature'), this.$t('common.warning'));
          }
        }
      });
      this.paletsReservados[0].items.forEach((e) => {
        e.checked = false;
      });
      this.modificado = true;
    },
    async ChangeTemperaturePaletsSelectedCargados() {
      Log(this, this.ChangeTemperaturePaletsSelectedCargados.name);
      this.paletsCargados[0].items.forEach(async (l) => {
        if (l.checked) {
          // this.newListaCheck.forEach(async (l) => {
          HiDialog.Preloader(true, this.$t('commercialization.info.changingPalletTemperature', { pallet: l.UnidadContenedora.NumeroSerie }), false);
          let result = { valor: false };
          try {
            result = await this.Conections_ChangeTemperaturePale(l.UnidadContenedora.Id, l.Id, this.temperatura);
          } catch (error) {
            LogError(this, this.ChangeTemperaturePaletsSelectedCargados.name, error);
          }
          HiDialog.Preloader(false);
          if (result.valor) {
            l.TemperaturaPale = this.temperatura;
          } else {
            HiNotification.Alert(this.$t('commercialization.info.couldNotChangePalletTemperature'), this.$t('common.warning'));
          }
        }
      });
      this.paletsCargados[0].items.forEach((e) => {
        e.checked = false;
      });
      this.modificado = true;
    },

    async ChargeSelectedPales() {
      Log(this, this.ChargeSelectedPales.name);
      const elementsSelected = this.paletsReservados[0].items.filter((item) => item.checked);
      const sound = elementsSelected.length === 1;
      for await (const item of elementsSelected) {
        await this.CompletePaleCharge(item, false, sound);
      }
      this.modificado = true;
    },
    async ChargePaleInExpedition(stringNumeroSerie, idNumeroSerie, idLineExpedition, idExpedition, mostrarPreload) {
      Log(this, this.ChargePaleInExpedition.name);
      if (!mostrarPreload) {
        HiDialog.Preloader(true, this.$t('commercialization.info.loadingPalletText', { pallet: stringNumeroSerie }), false);
      }

      let result = { valor: false };
      try {
        result = await this.Conections_ChangeStatusPallet(idNumeroSerie, idLineExpedition, idExpedition, 2);
      } catch (error) {
        if (!mostrarPreload) {
          HiDialog.Preloader(false);
        }
        LogError(this, this.ChargePaleInExpedition.name, error);
      }
      if (!mostrarPreload) {
        HiDialog.Preloader(false);
      }
      this.modificado = true;
      return result;
    },
    async CompletePaleCharge(l, mostrarPreload, sound = true) {
      Log(this, this.CompletePaleCharge.name);
      l.checked = false;
      const result = await this.ChargePaleInExpedition(l.UnidadContenedora.NumeroSerie, l.UnidadContenedora.Id, l.Id, this.lineSelected.Expedicion.Id, mostrarPreload);
      if (result.valor) {
        l.EstadoCarga = 2;
        this.paletsReservados[0].items = this.paletsReservados[0].items.filter((item) => item.Id !== l.Id);
        this.paletsCargados[0].items.push(l);
        if (!mostrarPreload) {
          this.ShowInfoPale(true, this.$t('commercialization.info.onePalletLoadedSuccessfully', { pallet: l.UnidadContenedora.NumeroSerie }));
        }
        if (sound) {
          this.soundCargaCorrecta.play();
        }
      } else if (!this.lecturaContinuaCargasExpediciones) {
        await this.Conexion_GetExpedition(this.expedition);
        this.ProcessingDataGET();
        const alertText = this.$t('commercialization.info.couldNotLoadPalletText', { pallet: l.UnidadContenedora.NumeroSerie });
        HiNotification.Alert(alertText, this.$t('common.warning'));
      }
      this.modificado = true;
      this.lineSelected.CantidadTotalCargada = this.paletsCargados[0].items.length;
    },

    async GoBackWithReload() {
      Log(this, this.GoBackWithReload.name);
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionDocument/', {
        ignoreCache: true,
        reloadPrevious: true,
        props: {
          expeditionDocument: this.lineExpedition.Expedicion,
          reload: true,
        },
      });
      await sleep(500);
      f7.views.main.router.back();
    },

    goBack() {
      Log(this, this.goBack.name);
      // Cambiado para que recargue siempre que volvamos atras ya que es posible que usemos la misma orden desde varios dispositivos
      this.GoBackWithReload();
      /* if (this.modificado) {
        this.GoBackWithReload();
      } else {
        f7.views.main.router.back();
      } */
    },
    async GoPageInitExpedition() {
      Log(this, this.GoPageInitExpedition.name);
      // f7.views.main.router.clearPreviousHistory();
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpedition/', {
        clearPreviousHistory: true,
      });
    },

    /** Method ProcessPaleReadForCharge */
    async ProcessPaleReadForCharge(value, noMostrarMenu) {
      Log(this, this.ProcessPaleReadForCharge.name);
      // Validaciones de Pale Antes de la carga
      if (!noMostrarMenu) {
        HiDialog.Preloader(true, this.$t('commercialization.info.validatingLoadingPallet'));
      }

      let responseInfoPaleForExpedition = null;
      try {
        responseInfoPaleForExpedition = await APIErp.callInfoStatusXSerialNumberForExpedition(value.Id);
        HiDialog.Preloader(false);
      } catch {
        HiDialog.Preloader(false);
        if (!this.lecturaContinuaCargasExpediciones) {
          HiNotification.Alert(this.$t('commercialization.info.anErrorHasOccurredQueryingPalletInformation', { pallet: value.NumeroSerie }));
        }

        return false;
      }

      let dataInfoPaleForExpedition = null;
      if (responseInfoPaleForExpedition != null && (responseInfoPaleForExpedition.statusText === 'OK' || responseInfoPaleForExpedition.status === 200)) {
        dataInfoPaleForExpedition = responseInfoPaleForExpedition.data;
      } else {
        if (!this.lecturaContinuaCargasExpediciones) {
          HiNotification.Alert(this.$t('commercialization.info.notPossibleToGetPalletInformationToLoad', { pallet: value.NumeroSerie }));
        }
        return false;
      }
      // 1º - El palé indicado ya está CARGADO en otra orden de carga.
      if (dataInfoPaleForExpedition.CargadoOrdenCarga && dataInfoPaleForExpedition.OrdenCargaReserva.Id !== this.lineSelected.Expedicion.Id) {
        if (!this.lecturaContinuaCargasExpediciones) {
          const couldNotLoadPalletText = this.$t('commercialization.info.couldNotLoadPalletText', { pallet: value.NumeroSerie });
          const loadingOrderReservation = `${dataInfoPaleForExpedition.OrdenCargaReserva.Serie}/${dataInfoPaleForExpedition.OrdenCargaReserva.Numero}`;
          const palletAlreadyLoadedInOtherLoadingOrder = this.$t('commercialization.info.palletAlreadyLoadedInOtherLoadingOrder', { order: loadingOrderReservation });

          const alertText = `${couldNotLoadPalletText}. ${palletAlreadyLoadedInOtherLoadingOrder}`;
          const alertTitle = this.$t('common.information');

          HiNotification.Alert(alertText, alertTitle);
        }
        return false;
      }
      // 2º - El palé indicado ya está CARGADO en ESTA orden de carga
      if (dataInfoPaleForExpedition.CargadoOrdenCarga && dataInfoPaleForExpedition.OrdenCargaReserva.Id === this.lineSelected.Expedicion.Id) {
        if (!this.lecturaContinuaCargasExpediciones) {
          const alertText = this.$t('commercialization.info.palletAlreadyLoadedInThisLoadingOrder', { pallet: value.NumeroSerie });
          const alertTitle = this.$t('common.information');
          HiNotification.Alert(alertText, alertTitle);
        }
        return false;
      }
      // 3º - El palé indicado ya está RESERVADO en otra orden de carga.
      if (dataInfoPaleForExpedition.ReservadoOrdenCarga && dataInfoPaleForExpedition.OrdenCargaReserva.Id !== this.lineSelected.Expedicion.Id) {
        if (!this.lecturaContinuaCargasExpediciones && !this.permitirMoverPalesReservadosEnOrdenCarga) {
          const couldNotLoadPalletText = this.$t('commercialization.info.couldNotLoadPalletText', { pallet: value.NumeroSerie });
          const loadingOrderReservation = `${dataInfoPaleForExpedition.OrdenCargaReserva.Serie}/${dataInfoPaleForExpedition.OrdenCargaReserva.Numero}`;
          const palletIsReservedInLoadingOrder = this.$t('commercialization.info.palletIsReservedInLoadingOrder', { order: loadingOrderReservation });
          const deleteLoadingOrderReservation = this.$t('commercialization.info.deleteLoadingOrderReservation');

          const alertText = `${couldNotLoadPalletText}. ${palletIsReservedInLoadingOrder}. ${deleteLoadingOrderReservation}`;
          const alertTitle = this.$t('common.information');

          HiNotification.Alert(alertText, alertTitle);
        }

        if (!this.permitirMoverPalesReservadosEnOrdenCarga) {
          return false;
        }

        if (!this.movePalletFromOtherLoadingOrder) {
          this.AskToMovePalletFromOtherLoadingOrder(value, dataInfoPaleForExpedition);
          return true;
        }
      }

      // 5º  Sol.292659 - Si el pale está reservado a otro pedido de venta consultamos el valor del parámetro de configuración `EliminarReservaAnteriorExpediciones`
      if ((dataInfoPaleForExpedition.PedidoVentaReserva != null) && (dataInfoPaleForExpedition.LineaPedidoVentaReserva.Id !== this.lineSelected.LineaPedidoVenta.Id)) {
        let samePackage = null;
        const existenceProduct = value.Existencias.filter((e) => e.Articulo.TipoArticulo === 'Producto')[0];
        const existenceContainer = value.Existencias.filter((e) => e.Articulo.TipoArticulo === 'Envase')[0];
        if (this.lineSelected.Producto.Id === dataInfoPaleForExpedition.NumeroSerieReserva.InfoProducto.Id && this.lineSelected.Envase.Id === existenceContainer.Articulo.Id) {
          samePackage = true;
        } else if (this.lineSelected.Producto.Familia?.Id === existenceProduct.Articulo.Familia?.Id && this.lineSelected.Envase.Id === existenceContainer.Articulo.Id) {
          samePackage = true;
        } else {
          samePackage = false;
        }
        if (!samePackage) {
          const alertText = this.$t('commercialization.info.palletHasNotSameAssemblyThanLine', { pallet: value.NumeroSerie });
          const alertTitle = this.$t('common.information');
          HiNotification.Alert(alertText, alertTitle);
          return false;
        }

        const selectedLineSalesOrder = `${this.lineSelected.LineaPedidoVenta.PedidoVenta.Serie}/${this.lineSelected.LineaPedidoVenta.PedidoVenta.Numero}`;
        const canAutoDeleteReservation = this.eliminarReservaAnteriorExpediciones
          || this.ValidateDeleteReservesInternalCustomer(dataInfoPaleForExpedition);

        if (!canAutoDeleteReservation && !noMostrarMenu) {
          const salesOrderReservation = `${dataInfoPaleForExpedition.PedidoVentaReserva.Serie}/${dataInfoPaleForExpedition.PedidoVentaReserva.Numero}`;

          const palletIsReservedInSalesOrder = this.$t('commercialization.info.palletIsReservedInSalesOrder', { pallet: value.NumeroSerie, salesOrder: salesOrderReservation });
          const doYouWantToCancelReservation = this.$t('commercialization.info.doYouWantToCancelReservation', { salesOrder: selectedLineSalesOrder });

          const actionsToPopover = f7.actions.create({
            buttons: [
              {
                text: `${palletIsReservedInSalesOrder}. ${doYouWantToCancelReservation}`,
                label: true,
              },
              {
                text: this.$t('common.reserve'),
                onClick: async () => {
                  try {
                    HiDialog.Preloader(true, this.$t('commercialization.info.reservingPalletInSalesOrder', { pallet: value.NumeroSerie, salesOrder: selectedLineSalesOrder }));
                    const r = await this.PaleProcessForReservationInLineSalesOrder(value, this.lineSelected.LineaPedidoVenta);
                    HiDialog.Preloader(false);
                    if (!r.Valor) {
                      HiNotification.Alert(r.Mensaje, this.$t('common.information'));
                      return;
                    }
                    await this.ProcessPaleReadForCharge(value); // Una vez reservado llamamos con recursividad para cargarlo.
                    await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
                    HiNotification.Toast(this.$t('commercialization.info.palletReservedInSalesOrder', { pallet: value.NumeroSerie, salesOrder: selectedLineSalesOrder }));
                    this.modificado = true;
                  } catch (error) {
                    LogError(this, this.ProcessPaleReadForCharge.name, error);
                  }
                },
              },
              {
                text: this.$t('common.cancel'),
                color: 'red',
              },
            ],
          });
          actionsToPopover.open();
        } else {
          HiDialog.Preloader(true, this.$t('commercialization.info.reservingPalletInSalesOrder', { pallet: value.NumeroSerie, salesOrder: selectedLineSalesOrder }));
          const r = await this.PaleProcessForReservationInLineSalesOrder(value, this.lineSelected.LineaPedidoVenta);
          HiDialog.Preloader(false);
          if (!r.Valor) {
            if (!this.lecturaContinuaCargasExpediciones) {
              HiNotification.Alert(r.Mensaje, this.$t('common.information'));
            } return false;
          }
          await this.ProcessPaleReadForCharge(value); // Una vez reservado llamamos con recursividad para cargarlo.
          await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
          HiNotification.Toast(this.$t('commercialization.info.palletReservedInSalesOrder', { pallet: value.NumeroSerie, salesOrder: selectedLineSalesOrder }));
          this.modificado = true;
          this.movePalletFromOtherLoadingOrder = false;
          return true;
        }

        // reservadoAOtroPedido = true;
        // const couldNotLoadPalletText = this.$t('commercialization.info.couldNotLoadPalletText', { pallet: value.NumeroSerie });
        // HiNotification.Alert(`${couldNotLoadPalletText}. El palé no se cargó ya que está reservado a un pedido distinto, elimine la reserva para continuar`, this.$t('common.information'));
        // Consultar el parametro de ERP EliminarReservaAnteriorExpediciones
        return true;
      }

      // 4º - El palé esta reservado en esta OC simulamos la carga desde el front.
      if (dataInfoPaleForExpedition.ReservadoOrdenCarga && dataInfoPaleForExpedition.OrdenCargaReserva.Id === this.lineSelected.Expedicion.Id) {
        this.CompletePaleCharge(this.paletsReservados[0].items.find((e) => e.UnidadContenedora.Id === value.Id), noMostrarMenu);
        return true;
      }

      // 6º - El palé indicado NO ESTA RESERVADO NI CARGADO. ¿Quieres Cargarlo?
      if (!dataInfoPaleForExpedition.ReservadoOrdenCarga && !dataInfoPaleForExpedition.CargadoOrdenCarga) {
        if (!noMostrarMenu) {
          const canAutoDeleteReservation = this.eliminarReservaAnteriorExpediciones
            || this.ValidateDeleteReservesInternalCustomer(dataInfoPaleForExpedition);

          if (this.permitirMoverPalesReservadosEnOrdenCarga && canAutoDeleteReservation) {
            this.OnlyReserve(value);
          } else {
            const actionsToPopover = f7.actions.create({
              buttons: [
                {
                  text: this.$t('commercialization.info.palletIsNotReservedDoYouWantToReserve', { pallet: value.NumeroSerie }),
                  label: true,
                },
                {
                  text: this.$t('commercialization.common.reserveOnly'),
                  bold: true,
                  onClick: async () => {
                    this.OnlyReserve(value);
                  },
                },
                {
                  text: this.$t('commercialization.common.reserveAndLoad'),
                  onClick: async () => {
                    await this.ReservationAndCharge(value);
                  },
                },
                {
                  text: this.$t('common.cancel'),
                  color: 'red',
                },
              ],
            });
            actionsToPopover.open();
          }
          return true;
        }
        return true;
      }

      await this.ReservationAndCharge(value);
      return true;
    },
    async OnlyReserve(unitContainerForCharge) {
      Log(this, this.OnlyReserve.name);

      const preloaderText = this.$t('commercialization.info.reservingPallet', { pallet: unitContainerForCharge.NumeroSerie });
      HiDialog.Preloader(true, preloaderText);

      try {
        const r = await this.PaleProcessForReservation(unitContainerForCharge);
        HiDialog.Preloader(false);
        await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
        if (r.Valor) {
          this.ShowInfoPale(true, this.$t('commercialization.info.palletIsReservedSuccessfully', { pallet: unitContainerForCharge.NumeroSerie }));
        } else {
          HiNotification.Alert(r.Mensaje, this.$t('common.information'));
        }
      } catch (error) {
        LogError(this, this.OnlyReserve.name, error);
        HiDialog.Preloader(false);
      }
    },
    async ReservationAndCharge(unitContainerForCharge) {
      Log(this, this.ReservationAndCharge.name);

      try {
        const preloaderText = this.$t('commercialization.info.reservingPallet', { pallet: unitContainerForCharge.NumeroSerie });
        HiDialog.Preloader(true, preloaderText);

        const r = await this.PaleProcessForReservation(unitContainerForCharge);
        HiDialog.Preloader(false);
        if (!r.Valor) {
          if (!this.lecturaContinuaCargasExpediciones) {
            HiNotification.Alert(r.Mensaje, this.$t('common.information'));
          }
          return;
        }
        await this.ProcessPaleReadForCharge(unitContainerForCharge); // Una vez reservado llamamos con recursividad para cargarlo.
        await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
        /* this.soundCargaCorrecta.play();
        this.ShowInfoPale(true, `Palé ${unitContainerForCharge.NumeroSerie} Cargado correctamente`); */
        this.modificado = true;
      } catch (error) {
        LogError(this, this.ProcessPaleReadForCharge.name, error);
      }
    },

    async PaleProcessForReservation(ansReservar) {
      Log(this, this.PaleProcessForReservation.name);
      const result = { Valor: false, Mensaje: '' };
      this.lecturaParaReservaActiva = false;

      let responseInfoPaleForExpedition = null;
      try {
        responseInfoPaleForExpedition = await APIErp.callInfoStatusXSerialNumberForExpedition(ansReservar.Id);
      } catch (error) {
        LogError(this, this.PaleProcessForReservation.name, error);
        result.Mensaje = error;
        return result;
      }
      if (responseInfoPaleForExpedition === null && responseInfoPaleForExpedition.statusText !== 'OK') {
        result.Mensaje = this.$t('commercialization.info.notPossibleToGetPalletInformationToReserve', { pallet: ansReservar.NumeroSerie });
        return result;
      }
      const resValidate = this.ValidatePaleForReservation(ansReservar, responseInfoPaleForExpedition.data);
      if (!resValidate.Valor) {
        return resValidate;
      }
      let resultReservation = null;
      // Obtenemos la primera linea disponible para reservar
      const lineExpeditionForReservation = this.lineSelected.Desglose.find((e) => e.Estado === 0 && e.UnidadContenedora === null);
      if (lineExpeditionForReservation === undefined) {
        HiNotification.Toast(this.$t('commercialization.info.totalLoadHasBeenReached'), 3000);
        await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
        result.Valor = false;
        result.Mensaje = this.$t('commercialization.info.couldNotReservePallet', { pallet: ansReservar.NumeroSerie });
        return result;
      }
      try {
        resultReservation = await APIErp.callReservarPaleXOrdenCarga(ansReservar.Id, lineExpeditionForReservation.Id, this.lineSelected.Expedicion.Id);
      } catch (error) {
        LogError(this, this.PaleProcessForReservation.name, error);
        result.Mensaje = error;
        return result;
      }
      if (resultReservation !== null && resultReservation.data.valor) {
        // await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
        const dl = this.lineSelected.Desglose.find((e) => e.Id === lineExpeditionForReservation.Id);
        dl.Estado = 1;
        dl.UnidadContenedora = ansReservar;
        this.paletsReservados[0].items.push({
          Estado: 1,
          Id: resultReservation.data.id,
          TemperaturaPale: 0,
          UnidadContenedora: ansReservar,
        });
        this.modificado = true;
        result.Valor = true;
        return result;
      }
      result.Valor = false;
      result.Mensaje = resultReservation.data.mensaje;
      return result;
    },

    // Reserva el palé indicado en la linea de pedido de venta de la orden de carga seleccionada.
    async PaleProcessForReservationInLineSalesOrder(objPale, objSalesOrderLine) {
      Log(this, this.PaleProcessForReservationInLineSalesOrder.name);
      try {
        const data = {
          ContainerUnit: objPale,
          SalesOrderLine: objSalesOrderLine,
          DeleteOtherReserves: true,
        };
        const responseReserve = await APIErp.callReservePaleOnSalesOrderLine(data);
        return responseReserve.data;
      } catch (error) {
        LogError(this, this.PaleProcessForReservationInLineSalesOrder.name, error);
        return { Valor: false, Mensaje: error };
      }
    },

    ValidatePaleForReservation(ansReservar, dataInfoPaleForExpedition) {
      Log(this, this.ValidatePaleForReservation.name);

      const couldNotReservePallet = this.$t('commercialization.info.couldNotReservePallet', { pallet: ansReservar.NumeroSerie });

      // 1º - El palé indicado ya está Reservado o Cargado en ESTA
      if (dataInfoPaleForExpedition.OrdenCargaReserva?.Id === this.lineSelected.Expedicion.Id) {
        const palletAlreadyLoadedInThisLoadingOrder = this.$t('commercialization.info.indicatedPalletAlreadyLoadedInThisLoadingOrder');
        const palletAlreadyReservedInThisLoadingOrder = this.$t('commercialization.info.indicatedPalletAlreadyReservedInThisLoadingOrder');
        const reservedText = dataInfoPaleForExpedition.CargadoOrdenCarga ? palletAlreadyLoadedInThisLoadingOrder : palletAlreadyReservedInThisLoadingOrder;

        const e1 = `${couldNotReservePallet}. ${reservedText}.`;

        return { Valor: false, Mensaje: e1 };
      }
      // 2º - El palé indicado ya está CARGADO o Reservado en OTRA orden de carga.
      if (dataInfoPaleForExpedition.CargadoOrdenCarga && dataInfoPaleForExpedition.OrdenCargaReserva?.Id !== this.lineSelected.Expedicion.Id) {
        const reservationLoadingOrder = `${dataInfoPaleForExpedition.OrdenCargaReserva.Serie}/${dataInfoPaleForExpedition.OrdenCargaReserva.Numero}`;
        const palletAlreadyLoadedInOtherLoadingOrder = this.$t('commercialization.info.palletAlreadyLoadedInOtherLoadingOrder', { order: reservationLoadingOrder });
        const palletAlreadyReservedInOtherLoadingOrder = this.$t('commercialization.info.palletAlreadyReservedInOtherLoadingOrder', { order: reservationLoadingOrder });
        const reservedText = dataInfoPaleForExpedition.CargadoOrdenCarga ? palletAlreadyLoadedInOtherLoadingOrder : palletAlreadyReservedInOtherLoadingOrder;

        const e1 = `${couldNotReservePallet}. ${reservedText}`;

        return { Valor: false, Mensaje: e1 };
      }
      return { Valor: true };
    },
    async ChargeAndAddForReservSelectedPales() {
      Log(this, this.ChargeAndAddForReservSelectedPales.name);
      const elementSelected = this.paletsSinReserva[0].items.filter((item) => item.checked);
      const palesSeleccionados = elementSelected.map((element) => element.UnidadContenedora);
      HiDialog.Preloader(true, this.$t('commercialization.info.reservingAndLoadingPallets'));
      const result = await APIErp.callReservarYCargarPaleXOrdenCarga(palesSeleccionados, this.lineSelected.Id, this.lineSelected.Expedicion.Id, this.lineSelected.LineaPedidoVenta.Id);
      HiDialog.Preloader(false);
      this.ProcessResponseChargePaleDirect(result.data);
      this.modificado = true;
      await this.Conexion_GetExpedition(this.expedition, true);
      this.ProcessingDataGET();
    },

    /** Method ProcessSelectedPalesReserve */
    async ProcessSelectedPalesReserve() {
      let errorInProcess = false;
      let messageError = '';
      const selectedElements = this.paletsSinReserva[0].items.filter((item) => item.checked);

      for await (const element of selectedElements) {
        const preloaderText = this.$t('commercialization.info.reservingPallet', { pallet: element.UnidadContenedora.NumeroSerie });
        HiDialog.Preloader(true, preloaderText);

        const r = await this.PaleProcessForReservation(element.UnidadContenedora);

        if (!r.Valor) {
          errorInProcess = true;
          messageError = `${messageError} ${r.Mensaje}`;
          HiDialog.Preloader(false);
          break;
        }

        this.paletsSinReserva[0].items.splice(this.paletsSinReserva[0].items.indexOf(element), 1);
        HiDialog.Preloader(false);
      }

      // await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
      if (errorInProcess) {
        await this.Conexion_GetExpedition(this.expedition, false);
        this.ProcessingDataGET();
        HiNotification.Alert(messageError, this.$t('common.information'));
      } else {
        this.ShowInfoPale(true, this.$t('commercialization.info.reservationsCompleted'));
      }

      this.modificado = true;
    },

    async AskToMovePalletFromOtherLoadingOrder(pallet, dataInfoPaleForExpedition) {
      Log(this, this.AskToMovePalletFromOtherLoadingOrder.name);

      const loadingOrder = dataInfoPaleForExpedition.OrdenCargaReserva;
      const loadingOrderText = `${loadingOrder.Serie ?? ''}/${loadingOrder.Numero}`;
      let actionsLabel = `${this.$t('commercialization.info.palletIsReservedInLoadingOrder', { order: loadingOrderText })}. `;

      const canAutoDeleteReservation = this.eliminarReservaAnteriorExpediciones
        || this.ValidateDeleteReservesInternalCustomer(dataInfoPaleForExpedition);

      if (!canAutoDeleteReservation) {
        actionsLabel += this.$t('commercialization.info.doYouWantToDeleteThisReservation');
      } else {
        actionsLabel += this.$t('commercialization.info.doYouWantToDeleteReservationAndReserveToCurrent');
      }

      const actionsInstance = f7.actions.create({
        buttons: [
          {
            text: actionsLabel,
            label: true,
          },
          {
            text: this.$t('common.confirm'),
            onClick: async () => {
              HiDialog.Preloader(true, this.$t('commercialization.info.movingLoadingOrderPallet'));
              try {
                const { data } = await callMoveReservedPalletDifferentExpedition(pallet.Id);
                HiDialog.Preloader(false);

                if (data.Valor === true) {
                  this.movePalletFromOtherLoadingOrder = true;
                  this.ProcessPaleReadForCharge(pallet);
                } else {
                  HiNotification.Toast(this.$t('commercialization.info.couldNotMoveLoadingOrderPallet'));
                }
              } catch (error) {
                LogError(this, this.AskToMovePalletFromOtherLoadingOrder.name, error);
                HiDialog.Preloader(false);
              }
            },
          },
          {
            text: this.$t('common.cancel'),
            color: 'red',
          },
        ],
      });
      actionsInstance.open();
    },

    /**
     * Validates whether it can delete consider the parameter and the customer configuration.
     * @param {Record<string, any>} dataInfoPaleForExpedition
     * @returns {boolean}
     */
    ValidateDeleteReservesInternalCustomer(dataInfoPaleForExpedition) {
      Log(this, this.ValidateDeleteReservesInternalCustomer.name);

      const customer = /** @type {Cliente | undefined} */ (dataInfoPaleForExpedition.PedidoVentaReserva?.Cliente);
      if (customer?.ClienteInterno) {
        const paramValue = this.eliminarReservaClientesInternosExpediciones;

        if (paramValue === EliminacionReservaClienteInterno.Siempre) {
          return true;
        }

        if (paramValue === EliminacionReservaClienteInterno.SinGeneracionDeDocumentosAutomaticos) {
          return !this.HasCustomerAutomaticDocumentsGeneration(customer);
        }
      }

      return false;
    },

    /**
     * Validates whether the customer has automatic documents generation.
     * @param {Cliente} customer
     * @returns {boolean}
     */
    HasCustomerAutomaticDocumentsGeneration(customer) {
      return !!customer.ProveedorRelacionado;
    },

    EventOpenActionsReservation(valor) {
      Log(this, this.EventOpenActionsReservation.name);
      if (valor) {
        this.actionReservationOpened = true;
        if (this.paletsReservados[0].items.filter((e) => e.checked).length > 0) {
          this.showOptionDeleteReservation = true;
          this.showOptionChargeReservation = true;
        } else {
          this.actionAdd = true;
          this.showOptionDeleteReservation = false;
          this.showOptionChargeReservation = false;
        }
      } else {
        this.actionReservationOpened = false;
      }
    },
    EventOpenReadAnsForReservation() {
      Log(this, this.EventOpenReadAnsForReservation.name);
      this.lecturaParaReservaActiva = true;
      // TODO: Is this needed?
      this.$refs.UCCodeScanner.Open();
    },
    async EventOpenReadAnsForCarga() {
      Log(this, this.EventOpenReadAnsForCarga.name);
      this.lecturaParaReservaActiva = false;

      if (!this.introduccionManualCBLecturaPalesExpeciones) {
        this.$refs.UCCodeScannerNotifyAddPale.OpenAuto();
      } else {
        this.$refs.UCCodeScannerNotifyAddPale.Open();
        await sleep(200);
        this.$refs.UCCodeScannerNotifyAddPale.SetFocusOnInputElement();
      }
    },
    async EventDeleteLine() {
      Log(this, this.EventDeleteLine.name);

      const alertTitle = this.$t('commercialization.deletingLoadingOrderLine.title');
      const alertText = this.$t('commercialization.deletingLoadingOrderLine.text', { order: `${this.expedition.Serie}/${this.expedition.Numero}` });

      const resultConfirm = await ConfirmDialogGH(alertText, alertTitle);
      if (!resultConfirm) {
        return;
      }

      HiDialog.Preloader(true, this.$t('commercialization.info.deletingExpeditionLine'));
      const resultSave = await this.DeleteLinesExpedition([this.lineExpedition]);
      HiDialog.Preloader(false);
      if (resultSave == null) {
        return;
      }
      // Si es la unica linea de Expedición disponible en la orden de carga volvemos al formulario inicial de ordenes de carga.
      if (this.expedition.Lineas.length === 1) {
        this.GoPageInitExpedition();
      } else {
        this.modificado = true;
        this.GoBackWithReload();
      }
    },
    async EventScannerPopupClose() {
      Log(this, this.EventScannerPopupClose.name);
      if (this.introduccionManualCBLecturaPalesExpeciones && this.lecturaContinuaCargasExpediciones) {
        await this.Conexion_GetExpedition(this.expedition, false);
        this.ProcessingDataGET();
      }
    },
    async EventScannerCamClose() {
      Log(this, this.EventScannerCamClose.name);
      await this.Conexion_GetExpedition(this.expedition, false);
      this.ProcessingDataGET();
    },
    async ShowInfoPale(correcto, mensaje, timeToDisplay = 1500) {
      this.infoSheetParams.subtitle1 = mensaje;
      if (correcto) {
        this.infoSheetParams.title = this.$t('common.information');
        this.infoSheetParams.state = 'ENTER';
      } else {
        this.infoSheetParams.title = this.$t('common.incidence');
        this.infoSheetParams.state = 'ERROR';
      }

      this.infoSheetParams.opened = true;
      await sleep(timeToDisplay);
      this.infoSheetParams.opened = false;
    },
    async EventBarCodeReading(code) {
      Log(this, this.EventBarCodeReading.name);

      if (this.lineSelected.CantidadTotalCargada >= this.lineSelected.CantidadTotalPales) {
        this.$refs.UCCodeScannerNotifyAddPale.ClosePopup();
        HiNotification.Toast(this.$t('commercialization.info.totalLoadHasBeenReached'));
      } else if (!this.lecturaContinuaCargasExpediciones) {
        this.$refs.UCCodeScannerNotifyAddPale.ClosePopup();

        HiDialog.Preloader(true, this.$t('codeScanner.info.validatingBarcode'));

        const result = await ConexionTA.callObtenePalePorCodigoDeBarras(code, true, false, true);
        HiDialog.Preloader(false);
        if (result.Valor) {
          const paleLeido = JSON.parse(result.Mensaje);
          this.$refs.PCPopupScanData.Show(paleLeido);
        } else {
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      } else {
        PreloaderGH(false);

        const obj = {
          Id: 0,
          CodigoBarrasPale: code,
        };
        this.continuousReadingsQueue.push(obj);

        if (this.continuousReadingsQueue.length === 1) {
          this.ProcessContinuousReadingPale(obj);
        }
      }
    },

    /** ** Método EventNumeroSerieReading */
    async EventNumeroSerieReading(code) {
      Log(this, this.EventNumeroSerieReading.name);

      if (this.lineSelected.CantidadTotalCargada >= this.lineSelected.CantidadTotalPales) {
        this.$refs.UCCodeScannerNotifyAddPale.ClosePopup();
        HiNotification.Toast(this.$t('commercialization.info.totalLoadHasBeenReached'));
      } else if (!this.lecturaContinuaCargasExpediciones) {
        // OPCION A- CARGAS DE PALÉS SIN LECTURA CONTINUA
        this.$refs.UCCodeScannerNotifyAddPale.ClosePopup();

        const preloaderText = this.$t('codeScanner.info.validatingSerialNumber');
        const cancellationText = this.$t('codeScanner.info.validationCanceled');
        PreloaderGH(true, true, preloaderText, cancellationText);

        const result = await ConexionTA.callObtenePalePorNumeroDeSerie(code, true, true, false);
        PreloaderGH(false);
        if (result.Valor) {
          const paleLeido = JSON.parse(result.Mensaje);
          this.$refs.PCPopupScanData.Show(paleLeido);
        } else {
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      } else {
        // OPCION B - CARGA DE PALÉS CON LECTURA CONTINUA

        const obj = {
          Id: 0,
          NumeroSerie: code,
        };
        this.continuousReadingsQueue.push(obj);

        if (this.continuousReadingsQueue.length === 1) {
          this.ProcessContinuousReadingPale(obj);
        }
      }
    },

    async ProcessContinuousReadingPale(pallet) {
      if (this.isProcessingContinousReadingsQueue) {
        return;
      }

      this.isProcessingContinousReadingsQueue = true;
      try {
        const result = await APIErp.callReservarYCargarPaleXOrdenCarga(
          [pallet],
          this.lineSelected.Id,
          this.lineSelected.Expedicion.Id,
          this.lineSelected.LineaPedidoVenta.Id,
        );

        await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
        this.ProcessResponseChargePaleDirect(result.data);

        this.lineSelected.CantidadTotalCargada = this.paletsCargados[0].items.length;
        this.modificado = true;

        await this.RepeatProcessContinuousReadingPale();
      } catch (error) {
        LogError(this, this.ProcessContinuousReadingPale.name, error);
        this.RepeatProcessContinuousReadingPale();
      }
    },

    async RepeatProcessContinuousReadingPale() {
      this.continuousReadingsQueue.shift();
      this.isProcessingContinousReadingsQueue = false;

      if (this.continuousReadingsQueue[0]) {
        await this.ProcessContinuousReadingPale(this.continuousReadingsQueue[0]);
      }
    },

    /** ** Método ProcessResponseChargePaleDirect */
    ProcessResponseChargePaleDirect(data) {
      Log(this, this.ProcessResponseChargePaleDirect.name);
      const elementOK = data.Tag.OK;
      const elementERROR = data.Tag.ERROR;

      if (elementOK.length > 0 && elementERROR.length === 0) {
        const pales = elementOK.map((element) => element.tag.UnidadContenedora.NumeroSerie);
        const message = pales.length === 1
          ? this.$t('commercialization.info.onePalletLoadedSuccessfully', { pallet: pales[0] })
          : this.$t('commercialization.info.palletsLoadedSuccessfully', { pallets: pales.join(', ') });
        this.ShowInfoPale(true, message);
        this.soundCargaCorrecta.play();
        // SIMULAMOS LA CARGA DEL PALE EN EL FRONT
        elementOK.forEach((el) => {
          this.paletsCargados[0].items.push(el.tag);
        });
      } else if (elementOK.length === 0 && elementERROR.length === 1) {
        this.ShowInfoPale(false, elementERROR[0].mensaje);
      } else if (elementOK.length === 0 && elementERROR.length > 0) {
        const pales = elementERROR.map((element) => element.tag.NumeroSerie);
        const errorMessage = pales.length === 1
          ? `${this.$t('commercialization.info.palletNotLoaded', { pallet: pales[0] })} ${elementERROR[0].mensaje}`
          : `${this.$t('commercialization.info.palletsNotLoaded', { pallets: pales.join(', ') })} ${elementERROR[0].mensaje}`;
        this.ShowInfoPale(false, errorMessage);
      } else if (elementOK.length > 0 && elementERROR.length > 0) {
        this.ShowInfoPale(false, `${this.$t('commercialization.info.somePalletsNotLoaded')} ${elementERROR[0].mensaje}`);
      }
    },
    /** ** Método EventConfirmScanData */
    async EventConfirmScanData(value) {
      Log(this, this.EventConfirmScanData.name);
      if (this.lecturaParaReservaActiva === true) {
        this.PaleProcessForReservation(value);

        const preloaderText = this.$t('commercialization.info.reservingPallet', { pallet: value.NumeroSerie });
        HiDialog.Preloader(true, preloaderText);

        const r = await this.PaleProcessForReservation(value);
        HiDialog.Preloader(false);
        await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
        if (r.Valor) {
          HiNotification.Toast(this.$t('commercialization.info.palletIsReservedSuccessfully', { pallet: value.NumeroSerie }));
        } else {
          HiNotification.Alert(r.Mensaje, this.$t('common.information'));
        }
        // HiNotification.Toast(this.$t('commercialization.info.palletIsReservedSuccessfully', { pallet: value.NumeroSerie }));
      } else if (this.lecturaParaReservaActiva === false) {
        this.ProcessPaleReadForCharge(value, false);
      }
    },

    /** */
    /** ********************** CONEXIONES */
    /** */
    /*
    Conections_GetExpeditionsLines(lineExpedition) {
      Log(this, this.Conections_GetExpeditionsLines.name);
      const params = {
        Expedicion: {
          Numero: lineExpedition.Expedicion,
        },
      };

      HiDialog.Preloader(true, this.$t('common.loadingData'));
      return new Promise((resolve, reject) => {
        APIErp.callGetExpeditions(params)
          .then((result) => {
            HiDialog.Preloader(false);
            const resultData = result.data;
            this.GetLineExpedition(resultData);
            this.ProcessingDataGET();
          }).catch((error) => {
            HiDialog.Preloader(false);
            LogError(this, this.Conections_GetExpeditionsLines.name, error);
            reject(error);
          });
      });
    },
    */
    async Conexion_GetExpedition(expeditionDocument, noMostrarPreload) {
      Log(this, this.Conexion_GetExpedition.name);
      if (!noMostrarPreload) {
        HiDialog.Preloader(true, this.$t('common.loadingData'));
      }
      const result = await APIErp.callGetExpedition(expeditionDocument, [0, 1, 2], this.userEnviroment.EntornoDeTrabajo.Centro);
      this.lineSelected = { ...result.data[0].Lineas.filter((e) => e.LineaPedidoVenta.Id === this.lineSelected.LineaPedidoVenta.Id)[0] };
      if (!noMostrarPreload) {
        HiDialog.Preloader(false);
      }
    },
    async Conections_ChangeStatusPallet(idArticuloNumeroSerie, idLineaOrdenCarga, idOrdenCarga, newState) {
      Log(this, this.Conections_ChangeStatusPallet.name);
      const res = await APIErp.callChangeStatusPale(idArticuloNumeroSerie, idLineaOrdenCarga, idOrdenCarga, newState);
      return res.data;
    },
    async Conections_ChangeTemperaturePale(idArticuloNumeroSerie, idLineaOrdenCarga, newTemperature) {
      Log(this, this.Conections_ChangeTemperaturePale.name);
      const res = await APIErp.callChangeTemperaturePale(idArticuloNumeroSerie, idLineaOrdenCarga, newTemperature);
      return res.data;
    },

    async DeleteLinesExpedition(objExpedition) {
      HiDialog.Preloader(true, this.$t('commercialization.info.deletingExpeditionLines'), false);
      try {
        const result = await APIErp.callDeleteLinesExpedition(objExpedition);
        HiDialog.Preloader(false);
        return result.data;
      } catch (error) {
        HiDialog.Preloader(false);
        HiNotification.Alert(error, this.$t('common.warning'));
        return null;
      }
    },
  },
};
</script>

<style lang="scss">
.main-expedition-document-add-pale {
  .disabled-component {
    opacity: 0.6;
    pointer-events: none;
  }

  .icon-custom-back {
    background-image: url("@/static/icons/ic_back.svg");
    width: 24px;
    height: 24px;
  }

  .content-data {
    .storybook-action-sorted-accordion .accordion-list .accordion-item-opened > .item-inner > ::after {
      border-top: 0;
    }

    &__row {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__col {
      display: flex;
      align-items: flex-start;
      flex-direction: column;

      &--gray {
        font-size: 10px;
        font-weight: 400;
        color: var(--his-ash-gray);
        text-transform: uppercase;
      }

      &--strong-blue {
        font-size: 16px;
        font-weight: 500;
        color: var(--his-slate-blue);
      }
    }

    &__info {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      min-width: 115px;

      img {
        margin-left: 5px;
      }

      &--yellow {
        background: #fce0b1;
        margin-right: 10px;
        padding-left: 4px;
        padding-right: 5px;
      }

      &--strong-blue {
        font-size: 22px;
        margin-right: 5px;
        font-weight: 500;
        color: var(--his-slate-blue);

        span {
          font-size: 18px;
          font-weight: 400;
        }
      }
    }

    .suboption-list {
      --f7-list-media-item-padding-vertical: 12px;
      --f7-list-item-title-font-size: 14px;
      --f7-list-item-title-text-color: var(--his-slate-blue);
      --f7-list-item-title-font-weight: 500;
      --f7-list-item-subtitle-font-size: 12px;
      --f7-list-item-subtitle-text-color: var(--his-ash-gray);
      --f7-list-item-subtitle-font-weight: 400;
      --f7-list-item-after-font-size: 22px;
      --f7-list-item-after-font-weight: 500;
      --f7-list-item-after-text-color: var(--his-slate-blue);
      --f7-list-item-after-line-height: 1;
      --f7-list-chevron-icon-area: 0;
      --f7-list-media-item-padding-horizontal: 5px;

      .suboption-list__mix {
        color: burlywood;
        padding-left: 5px;
      }
    }

    .suboption-list-fondo {
      --f7-list-media-item-padding-vertical: 12px;
      --f7-list-item-title-font-size: 14px;
      --f7-list-item-title-text-color: var(--his-slate-blue);
      --f7-list-item-title-font-weight: 500;
      --f7-list-item-subtitle-font-size: 12px;
      --f7-list-item-subtitle-text-color: var(--his-ash-gray);
      --f7-list-item-subtitle-font-weight: 400;
      --f7-list-item-after-font-size: 22px;
      --f7-list-item-after-font-weight: 500;
      --f7-list-item-after-text-color: var(--his-slate-blue);
      --f7-list-item-after-line-height: 1;
      --f7-list-chevron-icon-area: 0;
      --f7-list-media-item-padding-horizontal: 5px;

      .suboption-list__mix {
        color: burlywood;
        padding-left: 5px;
      }

      .media-item {
        .item-content {
          .item-inner {
            .item-title-row {
              .item-title {
                background: var(--his-melon-light);
                border-radius: 5px;
                padding-top: 3px;
                padding-left: 3px;
              }
            }
          }
        }
      }
    }

    .content-data-state {
      .span-charge-state {
        font-size: 24px;
      }

      .span-subtitle {
        font-size: 16px;
      }
    }

    .content-charge-reserved {
      border-bottom: 1px solid #ebebed;

      .items_orden {
        font-size: 18px;
      }

      .items_palets {
        font-size: 30px;
      }

      .items_place,
      .span-title {
        font-weight: 400;
        font-size: 12px;
        color: var(--his-ash-gray);
      }
    }
  }
}

.quantityCharged {
  font-size: 22px;
  margin-right: 5px;
  font-weight: 500;
  color: var(--his-slate-blue);
  display: flex;
  justify-content: center;
}

.img-delete {
  // margin-left: 25px;
}

.content-action {
  --f7-actions-label-justify-content: center;
  --f7-actions-label-text-color: var(--his-dark-blue);
  --f7-actions-label-font-size: 14px;
  --f7-actions-label-padding: 12px 16px;

  /*  --f7-actions-label-min-height: 0; */
  .actions-label {
    font-weight: 500;
  }

  &__buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    &--red {

      --f7-actions-button-text-color: var(--his-tomate);
      --f7-actions-grid-button-text-color: var(--his-tomate);

      .img-delete {
        // margin-left: 25px;
      }
    }

    &--gray {
      --f7-actions-grid-button-text-color: var(--his-slate-blue);

      .img-add {
        // margin-left: 25px;
      }
    }
  }

  &__options {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid var(--his-silver);
    margin: 16px 16px 0;

    div {
      padding: 8px 0;
      text-transform: uppercase;
    }

    &--gray {
      color: var(--his-ash-gray);
      font-size: 14px;
    }

    &--green {
      color: #66ba33;
      font-size: 18px;
    }
  }

  .actions-button {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 33.33333333%;
    display: block;
    color: var(--f7-actions-grid-button-text-color);
    height: auto;
    padding: 9px;
    text-transform: uppercase;
    margin-bottom: 5px;

    &--guardar {
      background: var(--his-melon);

      // margin-left: 5px;
      color: #fff;
    }

    &--cancelar {
      background: var(--his-tomate);
      margin-right: 5px;
      color: #fff;
    }
  }
}

.item-after {
  margin-left: 31em;
}

.media-list .item-link .item-title-row::before,
li.media-item .item-link .item-title-row::before {
  right: 0;
  visibility: hidden;
}

.content-list-checkbox-item {
  --f7-list-item-padding-horizontal: 10px;
  --f7-list-item-padding-vertical: 0;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  &__details {
    width: 100%;

    .item-inner {
      color: var(--his-slate-blue);
      font-size: 14px;
      font-weight: 500;
    }
  }
}

.input-temperatura {
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 130px;
  gap: 10px;
}
</style>
